import { FC } from 'react';

type Props = {
	className?: string;
};

const DashboardSquareIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#EAEAEA'
			className={className}>
			<path
				d='M13.2031 4.4001C13.2031 3.65456 13.2031 3.2818 13.3249 2.98774C13.4873 2.59569 13.7988 2.2842 14.1908 2.1218C14.4849 2 14.8577 2 15.6032 2C16.3488 2 16.7215 2 17.0156 2.1218C17.4076 2.2842 17.7191 2.59569 17.8816 2.98774C18.0033 3.2818 18.0033 3.65456 18.0033 4.4001V7.60023C18.0033 8.34576 18.0033 8.71852 17.8816 9.01261C17.7191 9.40462 17.4076 9.71616 17.0156 9.87856C16.7215 10.0003 16.3488 10.0003 15.6032 10.0003C14.8577 10.0003 14.4849 10.0003 14.1908 9.87856C13.7988 9.71616 13.4873 9.40462 13.3249 9.01261C13.2031 8.71852 13.2031 8.34576 13.2031 7.60023V4.4001Z'
				stroke='inherit'
				strokeWidth='1.25'
			/>
			<path
				d='M13.2031 15.6003C13.2031 14.8547 13.2031 14.482 13.3249 14.1879C13.4873 13.7959 13.7988 13.4844 14.1908 13.322C14.4849 13.2002 14.8577 13.2002 15.6032 13.2002C16.3488 13.2002 16.7215 13.2002 17.0156 13.322C17.4076 13.4844 17.7191 13.7959 17.8816 14.1879C18.0033 14.482 18.0033 14.8547 18.0033 15.6003C18.0033 16.3458 18.0033 16.7186 17.8816 17.0127C17.7191 17.4047 17.4076 17.7162 17.0156 17.8786C16.7215 18.0004 16.3488 18.0004 15.6032 18.0004C14.8577 18.0004 14.4849 18.0004 14.1908 17.8786C13.7988 17.7162 13.4873 17.4047 13.3249 17.0127C13.2031 16.7186 13.2031 16.3458 13.2031 15.6003Z'
				stroke='inherit'
				strokeWidth='1.25'
			/>
			<path
				d='M2 13.2001C2 11.6916 2 10.9373 2.46865 10.4687C2.93729 10 3.69157 10 5.20013 10H6.8002C8.30875 10 9.06301 10 9.53167 10.4687C10.0003 10.9373 10.0003 11.6916 10.0003 13.2001V14.8002C10.0003 16.3087 10.0003 17.063 9.53167 17.5317C9.06301 18.0003 8.30875 18.0003 6.8002 18.0003H5.20013C3.69157 18.0003 2.93729 18.0003 2.46865 17.5317C2 17.063 2 16.3087 2 14.8002V13.2001Z'
				stroke='inherit'
				strokeWidth='1.25'
			/>
			<path
				d='M2 4.4001C2 3.65456 2 3.2818 2.1218 2.98774C2.2842 2.59569 2.59569 2.2842 2.98774 2.1218C3.2818 2 3.65456 2 4.4001 2H7.60023C8.34576 2 8.71852 2 9.01261 2.1218C9.40462 2.2842 9.71616 2.59569 9.87856 2.98774C10.0003 3.2818 10.0003 3.65456 10.0003 4.4001C10.0003 5.14563 10.0003 5.5184 9.87856 5.81245C9.71616 6.20451 9.40462 6.516 9.01261 6.6784C8.71852 6.8002 8.34576 6.8002 7.60023 6.8002H4.4001C3.65456 6.8002 3.2818 6.8002 2.98774 6.6784C2.59569 6.516 2.2842 6.20451 2.1218 5.81245C2 5.5184 2 5.14563 2 4.4001Z'
				stroke='inherit'
				strokeWidth='1.25'
			/>
		</svg>
	);
};

export default DashboardSquareIcon;
